export const ReportUserAccessType = {
  Profile: 1,
  Identity: 2,
}

export const ReportUserAccessTypeNames = {
  [ReportUserAccessType.Profile]: 'Profile',
  [ReportUserAccessType.Identity]: 'Identity',
}
